import React, { type JSX, type ReactNode, useLayoutEffect } from 'react';

import Box from '@mui/material/Box';

import StdDialogTitle from 'components/Dialogs/StdDialogTitle';

type Props = {
  children: ReactNode;
  isDirty: boolean;
  onBack?: () => void;
  onClose: () => void;
  onRootModalDrawerDirtyChange?: (isDirty: boolean) => void;
  open: boolean;
  title: string;
};

export default function ScheduledTransactionRootModalDrawer({
  children,
  isDirty,
  onBack,
  onClose,
  onRootModalDrawerDirtyChange,
  open,
  title,
}: Props): JSX.Element | null {
  useLayoutEffect(() => {
    onRootModalDrawerDirtyChange?.(isDirty);
  }, [isDirty, onRootModalDrawerDirtyChange]);

  if (!open) {
    return null;
  }

  return (
    <Box
      aria-label={title}
      role='dialog'
      sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, width: '100%' }}
    >
      <StdDialogTitle
        variant='drawer'
        id='edit-recurrence-dialog'
        onBack={onBack}
        onClose={onClose}
        showBackButton={Boolean(onBack)}
        showCloseButton
      >
        {title}
      </StdDialogTitle>
      {children}
    </Box>
  );
}
